export default {
    module: ['route', 'vuex', 'core'],
    dependency: ['model', 'plugin'],
};


// WEBPACK FOOTER //
// ./src/vendor/config/load.js